import styled from "styled-components";

export const SelectButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f6f6f7;
  border-radius: 50px;
  border: 1px solid #e0e0e0;
  width: 90%;
  height: 48px;
  margin: 16px;
  font-size: 16px;
  font-weight: bold;
  color: black;
  cursor: pointer;
  padding: 0 18px;

  @media (min-width: 768px) {
    width: 50%;
  }
`;

export const SelectButtonIconContainer = styled.div`
  display: flex;
  width: 30px;
  height: 30px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;
